import { render } from "./bookmarkList.vue?vue&type=template&id=38c42dbd&scoped=true"
import script from "./bookmarkList.vue?vue&type=script&lang=js"
export * from "./bookmarkList.vue?vue&type=script&lang=js"

import "./bookmarkList.vue?vue&type=style&index=0&id=38c42dbd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38c42dbd"

export default script